import { useEffect, useState } from "react";
import { Form, message, Table, Tooltip } from "antd";
import moment from "moment";
import { RiFileExcel2Line, RiMailSendLine } from "react-icons/ri";
import { Popover as ManPopover } from "@mantine/core";
import { departments } from "../../utils/data";

import fetchDataArps from "../../services/fetchDataArps";
import PageHeader from "../../components/shared/PageHeader";
import formatMoney from "../../utils/formatMoney";

import {
  blobToDataUrl,
  ExportToExcel,
  getExportData,
} from "../../utils/XLSXExport";
import { useSendEmailMutation } from "../../store/endpoints/email/email";
import { BsCalendarCheck, BsChevronDown } from "react-icons/bs";
import { BiGridAlt } from "react-icons/bi";
import ClassWidget from "./components/ClassWidget";
import MainChart from "./components/MainChart";

export default function AllAssets() {
  const [assets, setAssets] = useState<any>([]);
  const [classes, setClasses] = useState<any>(new Array(6).fill({ count: 24 }));

  const [messageModal, toggleMessageModal] = useState(false);
  const [sendEmail, emailResult] = useSendEmailMutation();
  const [search, setSearch] = useState<string>("");
  const [isLoading, setLoading] = useState<boolean>(false);
  const [yearPopup, setYearPopup] = useState(false);
  const [opened, setOpened] = useState(false);
  const [year, setYear] = useState<number>(2022);
  const [count, setCount] = useState<number>(0);
  const [total, setTotal] = useState<number>(0);
  const [center, setCenter] = useState<any>({
    id: 1,
    name: "IT",
  });

  const yr = new Date().getFullYear();

  const years: any = [];

  for (let i = yr; i > 2013; i--) {
    years.push({ name: i });
  }

  const getTotal = (all: any) => {
    let count = 0;
    let total = 0;
    all?.forEach((item: any) => {
      count = count + item?.quantity;
      total = total + item?.price * item?.quantity;
    });
    // return { count, total };
    setCount(count);
    setTotal(total);
  };

  const [emailForm] = Form.useForm();

  const handleFetchClasses = async () => {
    setLoading(true);
    const uri = `assets/classes?year=${year}`;
    const response = await fetchDataArps(uri);
    setClasses(response?.payload);
    setLoading(false);
  };

  const handleFetchAssets = async () => {
    const uri = `assets/department?department=${center?.name}&year=${year}`;
    const response = await fetchDataArps(uri);
    setAssets(response?.payload[0]?.list);
    getTotal(response?.payload[0]?.list);
  };

  const refetchAssets = async (cr: any, yr: number) => {
    let uri: any = ``;
    if (cr?.name === "All Departments") {
      uri = `assets/department?year=${yr}`;
    } else {
      uri = `assets/department?department=${cr?.name}&year=${yr}`;
    }
    const response = await fetchDataArps(uri);
    setAssets(response?.payload[0]?.list);
    getTotal(response?.payload[0]?.list);
  };

  const refetchClasses = async (cr: any, yr: number) => {
    let uri: any = ``;
    if (cr?.name === "All Departments") {
      uri = `assets/classes?year=${yr}`;
    } else {
      uri = `assets/classes?department=${cr?.name}&year=${yr}`;
    }
    const response = await fetchDataArps(uri);
    setClasses(response?.payload);
  };

  const sendMail = async (values: any) => {
    const data = assets?.list?.map((record: any, index: number) => {
      return {
        "S/N": index + 1,
        Date: moment(record?.posting_date.toString()).format("Do MMM YYYY"),
        Description: record?.description ? record?.description : "-",

        Narrative: record?.narrative ? record?.narrative : "-",
        Department: record?.department ? record?.department : "-",
        "Cost Center": record?.cost_center ? record?.cost_center : "-",
        Origin: record?.origin ? record?.origin : "-",
        Shortname: record?.shortname ? record?.shortname : "-",
        "Expense Code": record?.expense_code ? record?.expense_code : "-",
        "Journal Reference": record?.journal_reference
          ? record?.journal_reference
          : "-",
        Amount: record?.base_value ? record?.base_value : "-",
      };
    });

    const raw = getExportData(data);
    const uri = await blobToDataUrl(raw);

    sendEmail({
      email: values.email,
      subject: values.subject,
      data: uri,
    });

    message.success("Email Sent Successfully");
    emailForm.resetFields();
    toggleMessageModal(false);
  };

  const columns = [
    {
      title: "S/N",
      width: 30,
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">{index + 1}</span>
      ),
    },
    {
      title: "Year",
      width: 30,
      render: (record: any) => (
        <span className="text-gray-700 truncate">
          {record?.year === " " ? "-" : record?.year}
        </span>
      ),
    },
    {
      title: "Supplier",
      width: 90,
      render: (record: any) => (
        <span className="text-gray-700 truncate">{record?.supplier}</span>
      ),
    },
    {
      title: "Description",
      width: 120,
      render: (record: any) => (
        <div className="text-gray-700 truncate">
          {record?.description === ""
            ? record?.description
            : record?.description}
        </div>
      ),
    },

    {
      title: "Purpose / Use",
      width: 220,
      render: (record: any) => (
        <div className="flex text-gray-700  px-4 py-1 cursor-pointer truncate">
          {record?.purpose ? record?.purpose : "-"}
        </div>
      ),
    },
    {
      title: "Asset Class",
      width: 80,
      render: (record: any) => (
        <span className="text-gray-700 text-center">
          {record?.asset_class ? record?.asset_class : "-"}
        </span>
      ),
    },
    {
      title: "LPO",
      width: 40,
      render: (record: any) => (
        <span className="text-gray-700 text-center">
          {record?.lpo_no ? record?.lpo_no : "-"}
        </span>
      ),
    },
    {
      title: "Qty",
      width: 30,
      render: (record: any) => (
        <div className="text-gray-700 text-center">
          {record?.quantity ? record?.quantity : "-"}
        </div>
      ),
    },
    {
      title: "Unit Price (TZS)",
      width: 80,
      render: (record: any) => (
        <div className="text-gray-700 text-right">
          {record?.tsh_amount ? formatMoney(record?.tsh_amount) : "-"}
        </div>
      ),
    },
    {
      title: "Amount (TZS)",
      width: 60,
      render: (record: any) => (
        <div className="text-gray-700 text-right">
          {record?.price ? formatMoney(record?.price * record?.quantity) : "-"}
        </div>
      ),
    },
  ];

  const refetch = () => {
    handleFetchAssets();
    handleFetchClasses();
  };

  useEffect(() => {
    handleFetchAssets();
    handleFetchClasses();
  }, []);

  return (
    <div className=" bg-gray-100">
      <div className="grid grid-cols-12 gap-x-2 px-4 mt-4">
        <div className="col-span-12 sm:col-span-6 border border-gray-300 p-2 bg-blue-200">
          <div className="flex flex-col px-4">
            <div className="uppercase">Total Assets Value (TZS)</div>
            <div className="text-lg font-bold">{formatMoney(total)}</div>
          </div>
        </div>
        <div className="col-span-12 sm:col-span-6 border border-gray-300 p-2 bg-purple-200">
          <div className="flex flex-col px-4">
            <div className="uppercase">Total Assets Count</div>
            <div className="text-lg font-bold">{Math.round(count)}</div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-12 gap-2 my-4 px-4">
        {classes?.map((item: any) => (
          <ClassWidget
            item={item}
            year={year}
            center={center}
            refetch={refetch}
          />
        ))}
      </div>
      <MainChart data={classes} year={year} center={center} />
      <div className="flex flex-col border border-gray-300 mx-4 rounded-lg mt-2 bg-white">
        <PageHeader
          title={`${center?.name} : ${year}`}
          subtitle={`KJG Assets`}
          tag={`Assets`}
          actions={
            <div className="flex flex-row">
              <div className="flex flex-row items-center">
                <div className="flex">
                  <ManPopover
                    className="cursor:pointer focus:outline-none bg-green-100  hover:text-white"
                    opened={opened}
                    onClose={() => setOpened(false)}
                    target={
                      <div
                        onClick={() => setOpened((o) => !o)}
                        className="border border-gray-300  py-2 px-2 cursor-pointer"
                      >
                        <div className="flex flex-row justify-between items-center bg-green-100 text-black hover:text-red-800">
                          <div className="flex justify-center items-center">
                            <BiGridAlt />
                            <span className="ml-2 trancate ">
                              {center?.name}
                            </span>
                          </div>
                          <div className="ml-2">
                            <BsChevronDown color={"#323232"} />
                          </div>
                        </div>
                      </div>
                    }
                    width={260}
                    position="bottom"
                    withArrow
                  >
                    <div className="flex flex-col">
                      <button
                        className="cursor-pointer hover:text-toyota text-left focus:outline-none"
                        onClick={() => {
                          let n = {
                            _id: 0,
                            name: "All Departments",
                          };
                          setCenter(n);
                          setOpened((o) => !o);
                          refetchAssets(n, year);
                          refetchClasses(n, year);
                        }}
                        key={center._id}
                      >
                        All Departments
                      </button>
                      {departments?.map((center: any, index: number) => (
                        <button
                          className="cursor-pointer hover:text-toyota text-left focus:outline-none"
                          onClick={() => {
                            setCenter(center);
                            setOpened((o) => !o);
                            refetchAssets(center, year);
                            refetchClasses(center, year);
                          }}
                          key={index}
                        >
                          {center?.name}
                        </button>
                      ))}
                    </div>
                  </ManPopover>
                  <ManPopover
                    className="cursor:pointer focus:outline-none bg-red-100  hover:text-white mx-2"
                    opened={yearPopup}
                    onClose={() => setYearPopup(false)}
                    target={
                      <div
                        onClick={() => setYearPopup((o) => !o)}
                        className="border border-gray-300  py-2 px-2 cursor-pointer"
                      >
                        <div className="flex flex-row justify-between items-center bg-red-100 text-black hover:text-red-800">
                          <div className="flex justify-center items-center">
                            <BsCalendarCheck />
                            <span className="ml-2 trancate ">
                              {year === 0 ? "All Years" : year}
                            </span>
                          </div>
                          <div className="ml-2">
                            <BsChevronDown color={"#323232"} />
                          </div>
                        </div>
                      </div>
                    }
                    width={260}
                    position="bottom"
                    withArrow
                  >
                    <div className="flex flex-col">
                      <button
                        className="cursor-pointer hover:text-toyota text-left focus:outline-none"
                        onClick={() => {
                          const y = 0;
                          setYear(y);
                          setYearPopup((o) => !o);
                          refetchAssets(center, y);
                          refetchClasses(center, y);
                        }}
                      >
                        All Years
                      </button>
                      {years?.map((year: any) => (
                        <button
                          className="cursor-pointer hover:text-toyota text-left focus:outline-none"
                          onClick={() => {
                            const y = year?.name;
                            setYear(year?.name);
                            setYearPopup((o) => !o);
                            refetchAssets(center, y);
                            refetchClasses(center, y);
                          }}
                          key={year.id}
                        >
                          {year?.name}
                        </button>
                      ))}
                    </div>
                  </ManPopover>

                  <Tooltip title="Export To Excel">
                    <button
                      color="#E50000"
                      className="flex ml-2 justify-center items-center border px-4 py-1 hover:bg-gray-100"
                      onClick={async () => {
                        const data = assets?.map(
                          (record: any, index: number) => {
                            return {
                              "S/N": index + 1,
                              Year: record?.year,
                              Description: record?.description
                                ? record?.description
                                : "-",

                              Supplier: record?.supplier
                                ? record?.supplier
                                : "-",
                              Quantity: record?.quantity
                                ? record?.quantity
                                : "-",
                              "Asset Class": record?.asset_class
                                ? record?.asset_class
                                : "-",
                              "Grand Total": record?.grandtotal
                                ? record?.grandtotal
                                : "-",
                            };
                          }
                        );
                        ExportToExcel(data, "Assets.xlsx");
                      }}
                    >
                      <RiFileExcel2Line size={20} color="black" />
                    </button>
                  </Tooltip>
                  <Tooltip title="Send Email">
                    <button
                      className="flex ml-2 justify-center items-center border px-4 py-1 hover:bg-gray-100"
                      onClick={async () => {
                        toggleMessageModal(true);
                      }}
                    >
                      <RiMailSendLine size={21} color="black" />
                    </button>
                  </Tooltip>
                </div>
              </div>
            </div>
          }
        />

        <div className="grid gap-x-0 grid-cols-12">
          <div className="col-span-12 sm:col-span-12 md:col-span-12">
            <Table
              columns={columns}
              dataSource={assets?.filter((asset: any) =>
                asset?.description?.includes(search)
              )}
              size="small"
              pagination={{ pageSize: 14 }}
              loading={isLoading}
              scroll={{ y: 660 }}
              rowKey="id"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
